<div *ngIf="loadindData$ | async; else contentData" class="loading-indicator-wrapper">
  <cbre-spinner-loading-indicator diameter="48"></cbre-spinner-loading-indicator>
</div>
<ng-template #contentData>
  <div class="elevator-wrapper noscroll-table">
    <div class="elevator-header">
      <div class="elevator__options">
        <div class="opt-iconlink" (click)="addElevatorBank()">
          <mat-icon class="action-icon" svgIcon="add" aria-hidden="false"></mat-icon
          ><span class="link-text" l10nTranslate>moreInfo.addElevatorBank</span>
        </div>
      </div>
    </div>
    <ng-template #noElevators>
      <span class="na-msg">No elevator bank information.</span>
    </ng-template>
    <form *ngIf="!!elevators.length; else noElevators" [formGroup]="elevatorsFG">
      <div class="table-content">
        <p-table
          class="p-datatable-custom table-elevator"
          [value]="elevators"
          [columns]="floorHeaders"
          formArrayName="elevator"
        >
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [ngClass]="col.headerClass" scope="col">
                <span l10nTranslate
                  >{{ col.header }}<span class="required-icon" *ngIf="col.required"> &#x2a; </span></span
                >
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-elevator let-elevatorIndex="rowIndex">
            <!-- elevatorIndex being used to retrieve form group from form array -->
            <tr [formGroupName]="elevatorIndex">
              <td class="elevator__select-control">
                <div class="dropdown-container">
                  <mat-form-field class="elevator-mat-select-field" floatLabel="never" appearance="outline">
                    <mat-select
                      hideSingleSelectionIndicator="true"
                      #faElevatorTypeSelect
                      panelClass="custom-dropdown"
                      name="elevatorTypeDesc"
                      formControlName="elevatorTypeDesc"
                      [placeholder]="'commonLabels.select' | xTranslate"
                      (focus)="faElevatorTypeSelect.open()"
                      disableOptionCentering
                    >
                      <mat-option (click)="faElevatorTypeSelect.close()">--</mat-option>
                      <mat-option
                        *ngFor="let elevatorType of elevatorTypes"
                        [value]="elevatorType.key"
                        (click)="faElevatorTypeSelect.close()"
                      >
                        {{ elevatorType.value }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </td>
              <td class="elevator__name">
                <input type="text" name="elevator" formControlName="elevatorBankName" />
              </td>
              <td class="elevator__stop">
                <div class="dropdown-container">
                  <mat-form-field
                    class="elevator-mat-select-field"
                    [hideRequiredMarker]="true"
                    floatLabel="never"
                    appearance="outline"
                  >
                    <mat-select
                      hideSingleSelectionIndicator="true"
                      #fsSelect
                      panelClass="custom-dropdown"
                      name="firstStop"
                      formControlName="firstStop"
                      [placeholder]="'commonLabels.select' | xTranslate"
                      (selectionChange)="changeStop(elevatorIndex)"
                      (focus)="fsSelect.open()"
                      disableOptionCentering
                    >
                      <mat-option
                        *ngFor="let floor of floorsOptions"
                        [value]="floor.value"
                        [disabled]="floor.disabled"
                        (click)="fsSelect.close()"
                      >
                        {{ floor.label }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div
                  class="errorMsg fx--mt-8"
                  *ngIf="elevatorFormArray.controls[elevatorIndex].get('firstStop').errors?.incorrect"
                >
                  First stop should not be greater than last stop
                </div>
              </td>
              <td class="elevator__stop">
                <div class="dropdown-container">
                  <mat-form-field
                    class="elevator-mat-select-field"
                    [hideRequiredMarker]="true"
                    floatLabel="never"
                    appearance="outline"
                  >
                    <mat-select
                      hideSingleSelectionIndicator="true"
                      #lsSelect
                      panelClass="custom-dropdown"
                      name="lastStop"
                      formControlName="lastStop"
                      [placeholder]="'commonLabels.select' | xTranslate"
                      (selectionChange)="changeStop(elevatorIndex)"
                      disableOptionCentering
                      (focus)="lsSelect.open()"
                    >
                      <mat-option
                        *ngFor="let floor of floorsOptions"
                        [value]="floor.value"
                        [disabled]="floor.disabled"
                        (click)="lsSelect.close()"
                      >
                        {{ floor.label }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </td>
              <td class="elevator__bank-capacity-uom">
                <div class="elevator__forms__item form-container">
                  <div class="form-container__item optselect" formGroupName="elevatorBankCapacity">
                    <input
                      miqOnlyNumbers
                      [restrictPaste]="false"
                      class="floor-size"
                      [class.error]="
                        elevatorFormArray.controls[elevatorIndex].get('elevatorBankCapacity').errors &&
                        elevatorFormArray.controls[elevatorIndex].get('elevatorBankCapacity')?.controls?.val?.invalid
                      "
                      type="number"
                      min="0"
                      name="elevatorBankCapacity"
                      formControlName="val"
                      (keydown.backspace)="
                        handleBackspace(
                          $event,
                          elevatorFormArray.controls[elevatorIndex].get('elevatorBankCapacity')?.controls?.val
                        )
                      "
                    />
                    <div class="dropdown-container">
                      <mat-form-field
                        floatLabel="never"
                        [hideRequiredMarker]="true"
                        [class.error]="
                          elevatorFormArray.controls[elevatorIndex].get('elevatorBankCapacity').errors != null &&
                          !elevatorFormArray.controls[elevatorIndex].get('elevatorBankCapacity')?.controls?.val?.invalid
                        "
                        appearance="outline"
                      >
                        <mat-select
                          [required]="
                            elevatorFormArray.controls[elevatorIndex].get('elevatorBankCapacity')?.controls?.val.value
                          "
                          #faElevatorBankCapacitySelect
                          [placeholder]="'commonLabels.select' | xTranslate"
                          panelClass="custom-dropdown"
                          name="elevatorBankCapacityUOM"
                          formControlName="uom"
                          (focus)="faElevatorBankCapacitySelect.open()"
                          panelWidth
                          hideSingleSelectionIndicator="true"
                        >
                          <mat-option (click)="faElevatorBankCapacitySelect.close()">--</mat-option>
                          <mat-option
                            *ngFor="let uom of elevatorBankCapacityUOMValues"
                            [value]="uom.key"
                            (click)="faElevatorBankCapacitySelect.close()"
                          >
                            {{ uom.value }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                </div>

                <div
                  class="errorMsg fx--mt-8"
                  *ngIf="
                    !elevatorFormArray.controls[elevatorIndex].get('elevatorBankCapacity')?.controls?.val?.invalid &&
                    elevatorFormArray.controls[elevatorIndex].get('elevatorBankCapacity').errors != null
                  "
                >
                  Elevator bank capacity UOM is empty
                </div>
                <div
                  class="errorMsg fx--mt-8"
                  *ngIf="elevatorFormArray.controls[elevatorIndex].get('elevatorBankCapacity')?.controls?.val?.invalid"
                >
                  Elevator bank capacity value is invalid
                </div>
              </td>
              <td class="elevator__ada_complaint">
                <div class="dropdown-container">
                  <mat-form-field class="elevator-mat-select-field" floatLabel="never" appearance="outline">
                    <mat-select
                      hideSingleSelectionIndicator="true"
                      #faADACompliantSelect
                      panelClass="custom-dropdown"
                      name="adaCompliant"
                      formControlName="adaCompliant"
                      [placeholder]="'commonLabels.select' | xTranslate"
                      (focus)="faADACompliantSelect.open()"
                      disableOptionCentering
                    >
                      <mat-option (click)="faADACompliantSelect.close()">--</mat-option>
                      <mat-option
                        *ngFor="let item of adaCompliantOptions"
                        [value]="item.key"
                        (click)="faADACompliantSelect.close()"
                      >
                        {{ item.value }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </td>
              <td class="elevator__notes">
                <input type="text" name="notes" formControlName="elevatorBankNotes" />
              </td>
              <td class="elevator__delete">
                <mat-icon
                  class="action-icon"
                  svgIcon="delete"
                  aria-hidden="false"
                  (click)="deleteElevator(elevatorIndex, elevator)"
                ></mat-icon>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </form>
    <div class="button-container">
      <button
        mat-flat-button
        color="primary"
        class="btn btn-submit"
        [disabled]="elevatorsFG.invalid || elevatorsFG.pristine"
        (click)="saveElevatorInfo()"
        l10nTranslate
      >
        commonLabels.save
      </button>
    </div>
  </div>
</ng-template>
